import React from 'react';
import './custom-modal.scss';
import Close from '@svg/close.svg?react';
import useModal from 'antd/es/modal/useModal';
import { ModalFuncProps } from 'antd/es';
import ErrorIcon from '@svg/error.svg?react';

export interface CustomModalProps {
    title: string;
    cancelText?: string;
    okText?: string;
    onOk?: () => void | Promise<void>;
    onCancel?: (event: any) => void;
    body: (onClose: ()=>void) => React.ReactElement;
    icon?: React.ReactNode;
    getFooter?: (onClose: ()=>void) => React.ReactNode;
    height?: string;
    width?: number;
    closable?: boolean;
    destroyModal?: () => void;
    wrapClassName?: string,
    hideConfirmBtns?: boolean;
}

const useCustomModal = (): [(props: CustomModalProps) => void,
    (modalObj: any, title?: string, message?: string) => void,
    React.ReactElement] => {

    const [modal, contextHolder] = useModal();

    const showModal = (props: CustomModalProps) => {

        const { title, cancelText, okText, onOk, onCancel, body, width, height, closable, icon, wrapClassName, getFooter, hideConfirmBtns } = props;

        const baseProps: Partial<ModalFuncProps> = {
            width,
            closable,
            mask: true,
            className: 'custom-modal',
            closeIcon: <Close className="close-icon" />,
            centered: true,
            icon: icon || null,
            okButtonProps: !hideConfirmBtns ? { className: 'custom-btn primary-btn large-btn'}: { style: { display: 'none' }},
            cancelButtonProps: {
                className: 'custom-btn secondary-btn large-btn',
                style: { display: cancelText ? '' : 'none' }
            },
            wrapClassName
        };



        const additionalProps: Partial<ModalFuncProps> = {
            title,
            cancelText,
            okText,
            onOk,
            onCancel,
        };

        const modalInstance = modal.confirm({ ...baseProps, ...additionalProps });
        props.destroyModal = modalInstance.destroy;
        const content = (
            <div className="custom-modal-content">
                <div className="modal-message-container" style={{ height: height ?? '' }}>
                    {body(props.destroyModal)}
                </div>
                {getFooter && <div className="custom-modal-footer">{getFooter(props.destroyModal)}</div>}
            </div>
        );
        modalInstance.update({content});
    };

    const showErrorModal = (modalObj: any = {},
        title = 'Something went wrong',
        message = `We are having a problem.\nPlease try again or contact your administrator.`,
    ) => {
        showModal({
            title,
            width: 560,
            body: () => message,
            centered: true,
            className: 'error-modal',
            type: 'confirm',
            icon: <span role="img" aria-label="close-circle" className="anticon anticon-close-circle">
                <ErrorIcon></ErrorIcon></span>,
            ...modalObj
        });
    };

    return [showModal, showErrorModal, contextHolder];
};

export default useCustomModal;
